import {
  GET_COMPANY_EPISODES,
  GET_COMPANY_EPISODE,
  COMPANY_ERROR,
} from "../actions/types";

const initialState = {
  episodes: [],
  recentepisode: {},
  currentepisode: {},
  companyloading: true,
  episodeserror: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_COMPANY_EPISODES:
      return {
        ...state,
        episodes: payload,
        companyloading: false,
      };
    case GET_COMPANY_EPISODE:
      return {
        ...state,
        currentepisode: payload,
        companyloading: false,
      };
    case COMPANY_ERROR:
      return {
        ...state,
        episodeserror: payload,
        companyloading: false,
      };
    default:
      return state;
  }
}
